import type { ReactNode } from "react";
import type React from "react";
import { isGitHubAppEnabled } from "./getGitHubAppSettings";
const GitHubSettingsVisibility = ({ children, disabledContent, loadingContent }: React.PropsWithChildren<{
    disabledContent?: ReactNode;
    loadingContent?: ReactNode;
}>) => {
    if (isGitHubAppEnabled()) {
        return <>{children}</>;
    }
    if (disabledContent) {
        return <>{disabledContent}</>;
    }
    return null;
};
export default GitHubSettingsVisibility;
